var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2446 9.43369L12.2446 24.4337C12.114 24.5648 11.9587 24.6688 11.7878 24.7398C11.6169 24.8108 11.4336 24.8473 11.2485 24.8473C11.0635 24.8473 10.8802 24.8108 10.7093 24.7398C10.5383 24.6688 10.3831 24.5648 10.2524 24.4337L3.68994 17.8712C3.55913 17.7404 3.45537 17.5851 3.38457 17.4142C3.31378 17.2433 3.27734 17.0601 3.27734 16.8751C3.27734 16.6901 3.31378 16.5069 3.38457 16.336C3.45537 16.1651 3.55913 16.0098 3.68994 15.879C3.82075 15.7482 3.97604 15.6444 4.14695 15.5736C4.31786 15.5028 4.50104 15.4664 4.68603 15.4664C4.87103 15.4664 5.05421 15.5028 5.22512 15.5736C5.39603 15.6444 5.55132 15.7482 5.68213 15.879L11.2497 21.4466L25.2548 7.44385C25.519 7.17966 25.8773 7.03125 26.2509 7.03125C26.6245 7.03125 26.9828 7.17966 27.247 7.44385C27.5112 7.70803 27.6596 8.06633 27.6596 8.43994C27.6596 8.81355 27.5112 9.17185 27.247 9.43603L27.2446 9.43369Z",
    fill: "#004A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/IconCheckGreen.cd544edcd9fd25294c143b4292e855f7.svg";
export { ForwardRef as ReactComponent };